export default __webpack_public_path__ + "static/media/evcharger1.c2223897.jpg";